import { Popover } from "antd"

import MonthStatus from "../../../VAMP/components/MonitoringProgram/MonthStatus/MonthStatus"
import { STATUS_LABELS } from "../monitoringCopy"

import "./MonthStatusTrigger.less"

const MonthStatusTrigger = ({ icon, variant, status, monthName, popover }) => {
  if (!popover) return <MonthStatus icon={icon} variant={variant} />

  return (
    <Popover
      trigger="click"
      placement="bottom"
      overlayClassName="month-popover-overlay"
      getPopupContainer={() => document.getElementById("main-layout") || document.body}
      destroyTooltipOnHide
      content={popover}
    >
      <button
        type="button"
        className="month-status-trigger"
        aria-haspopup="dialog"
        aria-label={`${monthName} — ${STATUS_LABELS[status] ?? ""}`}
      >
        <MonthStatus icon={icon} variant={variant} />
      </button>
    </Popover>
  )
}

export default MonthStatusTrigger
